import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success(`Welcome back, ${user.name}`);
      if (next) navigate(next);
      else navigate(user.role === "admin" ? "/admin" : "/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-24" data-testid="login-page">
      <div className="label-eyebrow mb-3">Sign In</div>
      <h1 className="font-serif-display text-4xl text-white">Welcome <span className="italic text-[#D4AF37]">back</span></h1>
      <form onSubmit={submit} className="mt-10 space-y-4">
        <div>
          <label className="text-xs tracking-widest uppercase text-neutral-400">Email</label>
          <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 w-full bg-black border border-white/15 focus:border-[#D4AF37] outline-none px-4 py-3 rounded text-white" />
        </div>
        <div>
          <label className="text-xs tracking-widest uppercase text-neutral-400">Password</label>
          <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 w-full bg-black border border-white/15 focus:border-[#D4AF37] outline-none px-4 py-3 rounded text-white" />
        </div>
        <button data-testid="login-submit" disabled={loading} className="btn-gold w-full py-3 rounded text-sm tracking-widest uppercase font-semibold">
          {loading ? "Signing in..." : "Sign In"}
        </button>
      </form>
      <p className="text-sm text-neutral-400 mt-6 text-center">
        New here? <Link to="/register" className="text-[#D4AF37] hover:text-[#FCE68A]">Create an account</Link>
      </p>
    </div>
  );
}
